import { Component, OnInit } from '@angular/core';
import { PagoIngresoService } from '@app/core/service/pago-ingreso.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CreatePagopComponent } from './create-pagop/create-pagop.component';

@Component({
  selector: 'app-pago-proveedor',
  templateUrl: './pago-proveedor.component.html',
  styleUrls: ['./pago-proveedor.component.css']
})
export class PagoProveedorComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  pagos:any;
  constructor(private pagoService:PagoIngresoService,  private modalService: NgbModal ) { }

  ngOnInit() {
    this.listarPagos();
  }

  listarPagos()
  {
   this.pagoService.getAll().subscribe(a=>{
    this.pagos = a.data;
    console.log(this.pagos);
   })


  }

  createPago() {
    const modalRef = this.modalService.open(
      CreatePagopComponent,
      this.modalOptions
    );
    modalRef.componentInstance.title = 'Crear nuevo pago proveedor';
    modalRef.result.then(result => {
      if (result) {
        this.listarPagos();
      }
    });
  }

  

}
